<style lang="less" scoped>
  .home {
    text-align: center;
    //   padding: 56px;
    height: 100%;
    width: 100%;
    // background: url(../../assets/home-bg.png) no-repeat center bottom;
    background-size: 100% auto;
    /*p {*/
    /*  font-size: 3.25rem;*/
    /*  font-weight: bold;*/
    /*  text-shadow: 5px 1px 5px rgba(45, 140, 240, 0.4);*/
    /*}*/
    /*a {*/
    /*  font-size: 1.25rem;*/
    /*}*/

    .home_top {
      width: 100%;
      display: flex;
      text-align: left;

      .home_top_first {
        width: 40%;
        /*height: 20%;*/
        height: 200px;
        background: #FFFFFF;
        box-shadow: 0rem 0.17rem 0.33rem 0rem rgba(38, 45, 59, 0.0300);
        margin-right: 15px;
      }

      .home_top_second {
        width: 24%;
        /*height: 21%;*/
        height: 200px;
        background: #FFFFFF;
        box-shadow: 0rem 0.17rem 0.33rem 0rem rgba(38, 45, 59, 0.0300);
        margin-right: 15px;
      }

      .home_top_third {
        flex: 1;
        /*height: 21%;*/
        height: 200px;
        background: url(../../assets/home/img/banner.png) no-repeat;
        background-size: 100% 110%;
        position: relative;

        .time {
          position: absolute;
          top: 55px;
          left: 25px;
          font-size: 44px;
          // font-family: DINAlternate-Bold, DINAlternate;
          // font-weight: bold;
          color: #FFFFFF;

          span {
            font-size: 20px;
          }
        }

        .date {
          position: absolute;
          bottom: 58px;
          left: 38px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          letter-spacing: 1px;
        }
      }

      //公共标题
      .home_top_title {
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        padding: 20px 20px 0 20px;
        font-size: 1.38rem;
      }

      .home_top_box {
        display: flex;
        justify-content: space-around; // 两端平均分配对齐
        flex-wrap: wrap; // 超出换行
        align-content: space-around; // 垂直平均分配

        p {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .kjrk {
          display: flex;
          width: 13rem;
          height: 6.5rem;
          background: linear-gradient(180deg, #F3FAFF 0%, #D0E7FF 100%);
          box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.08);
          border-radius: 6px;
          border: 2px solid #FFFFFF;
          align-items: center;
          justify-content: space-between;
          padding-left: 0.8rem;
          margin-top: 0.9375rem;
          cursor: pointer;

          .kjrkleft {
            p {
              font-weight: 400;
              line-height: 22px;
              font-size: 18px;

              &:first-child {
                font-size: 20px;
                // font-weight: bold;
                line-height: 28px;
                margin-bottom: 0.2rem;
              }
            }

          }

          &.blue {
            p {
              color: #6A87A5;

              &:first-child {
                color: #2993FF;
              }
            }
          }

          &.red {
            background: linear-gradient(180deg, #FFF5F5 0%, #FEDDDD 100%);

            p {
              color: #A56A6A;

              &:first-child {
                color: #FE5858;
              }
            }
          }

          &.orange {
            background: linear-gradient(180deg, #FFF8EF 0%, #FFE1C7 100%);

            p {
              color: #AB8972;

              &:first-child {
                color: #FA8838;
              }
            }
          }
        }

        .flex_box {
          text-align: center;
          margin-top: 0.9375rem;
          cursor: pointer;

          img {
            width: 4.5rem;
            height: 4.5rem;
          }

          p {
            // margin-top: 15px;
            color: #555555;
            font-size: 16px;
            text-align: center;
            /*margin-bottom: 32px;*/
          }
        }
      }

      .home_top_second > .home_top_box {
        display: flex;
        justify-content: inherit;

        .flex_box:nth-child(1) {
          margin-left: 14px;
          margin-right: 30px;
        }

        .flex_box:nth-child(2) {
          margin-left: 14px;
          margin-right: 40px;
        }

      }
    }

    .home_main {
      // margin-top: 18px;
      width: 100%;
      height: calc(100% - 205px);
      display: flex;
      box-sizing: border-box;

      .home_main_left {
        width: 65%;
        height: 100%;
        box-sizing: border-box;
        // display: flex;
        // justify-content: space-between;

        .home_main_box {
          width: 100%;
          height: calc((100% - 31px) / 2);
          // width: calc((100% - 15px) / 2);
          margin-top: 16px;
          // margin-bottom: 16px;
          background: #FFFFFF;
          box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.0300);
          box-sizing: border-box;
        }

        // .home_main_box:nth-child(1) {
        //   margin-right: 15px;
        // }
        .outer_pad {
          width: 100%;
          height: calc(100% - 70px);
          box-sizing: border-box;
          //  height:150px;
          overflow: hidden;
          padding: 0px 20px 15px 15px;
          // overflow-y: auto;
          .home_main_table {
            width: 100%;
            height: 100%;
            background-color: #ffffff;
            overflow: hidden;

            // margin: 0px 20px 15px 15px;
          }

        }
      }

      .home_main_right {
        flex: 1;
        margin-left: 15px;
        text-align: left;
        height: calc(100% - 16px);
        background: #FFFFFF;
        margin-top: 16px;
        box-sizing: border-box;
      }

    }

    .home_main_title {
      padding-top: 20px;
      margin: 0px auto 25px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        display: flex;
        align-items: center;

        .huiji {
          background: #FF4141;
          border-radius: 9px;
          color: #ffffff;
          font-size: 16px;
          padding: 0rem 0.3rem;
          font-weight: 300;
          margin-left: 0.5rem;
          height: 19px;
          line-height: 19px;
        }
      }

      .select {
        width: 150px;
        height: 30px;
        border-radius: 3px;
        float: right;
        margin-right: 20px;
      }
    }

    .outer_pad {
      width: 100%;
      height: 560px;
      overflow-y: auto;
    }

    .home_main_content {
      background: #F7F8FA;
      margin: 0px 20px 16px 20px;

      p {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* 指定行数*/
        -webkit-box-orient: vertical;
        overflow: hidden;
        padding: 23px 19px 0px 20px;
      }

      div {
        padding: 16px 19px 22px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        .wcl {
          color: #FF0E0E;
        }

        .ycl {
          color: #0AB13B;
        }

        span:nth-child(1) {
          border: 1px solid #D8E6FF;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2977FF;
          padding: 0 4px;
        }
      }
    }

    .home_main_box_top {
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgba(38, 45, 59, 0.0300);
      overflow: hidden;
      margin-bottom: 16px;
      box-sizing: border-box;

      .top {
        padding: 20px 20px;

        .title {
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
        }

        .more {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #888888;
          float: right;
          cursor: pointer;
        }
      }

      .list {
        padding: 0 20px;
        margin-bottom: 10px;
        overflow: hidden;

        .list-item {
          margin-bottom: 10px;
          height: 100%;

          &::after {
            height: 0;
            content: "";
            display: block;
            clear: both;
          }

          .title {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            width: 80%;
            word-break: break-all;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* 指定行数*/
            -webkit-box-orient: vertical;
            overflow: hidden;
            float: left;

            .newicon {
              padding: 0.05rem 0.2rem;
              background: linear-gradient(360deg, #FFAE4E 0%, #FC7B14 100%);
              border-radius: 100px 100px 100px 0px;
              color: #ffffff;
              font-size: 12px;
            }
          }

          .time {
            width: 20%;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            float: right;
            text-align: right;
          }
        }

      }
    }

    .home_main_box_bottom {
      width: 100%;
      background-color: #ffffff;
      // height: 480px;
      // margin-bottom: 16px;
      box-sizing: border-box;
      // padding-bottom: 0.4rem;
      .title {
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        padding: 20px 20px 10px 20px;
      }

      /deep/ .zx-calendar.type-is-date .zx-calendar-header-wrapper .__title-wrapper {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        letter-spacing: 1px;
        line-height: 33px;
      }

      /deep/ .zx-calendar .zx-calendar-header-wrapper {
        margin-bottom: 10px;
      }

    }
  }

  .wcl {
    color: #FF0E0E;
  }

  .ycl {
    color: #0AB13B;
  }

  .blue {
    color: #2977FF;
  }

  .nolist {
    text-align: center;
    width: 100%;
    background-color: #ffffff;

    img {
      width: 150px;
    }

    p {
      font-size: 22px;
      font-weight: 500;
      color: #B2B2B2;
    }
  }

  .caozuo {
    color: #555555;
    cursor: pointer;

    &.blue {
      color: #2977FF;
    }

    img {
      width: 24px;
      vertical-align: middle;
    }
  }

  /deep/ .el-table::before {
    height: 0;
  }

  /deep/ .el-table {
    width: 100%;
    height: 100%;


  }

  /deep/ .el-table__body-wrapper {
    width: 100%;
    height: 75%;
    overflow: hidden;
    overflow-y: scroll;
  }

  /deep/ .el-table td.el-table__cell, /deep/ .el-table th.el-table__cell.is-leaf {
    border-bottom: 0px solid #EBEEF5;
    border: 0;
    // border-top: 1px dotted #939393;
  }

  /deep/ .el-table th.el-table__cell.is-leaf {
    background-color: rgba(0, 0, 0, 0.02);
    color: #222222;
    font-weight: 500;
  }

  /deep/ .el-table td.el-table__cell {
    border-top: 2px dotted #939393;
    color: #555555;
  }

  /deep/ .zx-calendar .zx-calendar-body-wrapper .__item.is-current .__inner .__text {
    background: #2977FF;
    // border-radius: 5px;
    // border: 1px solid #2977FF;
    color: #ffffff;
  }

  /deep/ .zx-calendar .zx-calendar-body-wrapper .__item {
    margin: 0;
  }

  /deep/ .zx-calendar {
    padding: 0;
  }
</style>

<template>
  <div class="home">
    <div class="home_top">
      <div class="home_top_first">
        <p class="home_top_title">快捷入口</p>
        <div class="home_top_box">
          <!--          <div class="flex_box">-->
          <!--            <img src="../../assets/home/sqmy.png" alt="">-->
          <!--            <p>我的待办</p>-->
          <!--          </div>-->
          <div class="kjrk blue" @click="jumpPage(1)">
            <div class="kjrkleft ">
              <p>招聘就业</p>
              <p>快速进入></p>
            </div>
            <img src="../../assets/home/img/zpjy.png" alt="">
          </div>
          <div class="kjrk red" @click="jumpPage(0)">
            <div class="kjrkleft ">
              <p>社情民意</p>
              <p>快速进入></p>
            </div>
            <img src="../../assets/home/img/sqmy.png" alt="">
          </div>
          <div class="kjrk orange" @click="jumpPage(2)">
            <div class="kjrkleft ">
              <p>爱心帮助</p>
              <p>快速进入></p>
            </div>
            <img src="../../assets/home/img/axbz.png" alt="">
          </div>
          <!-- <div class="flex_box" @click="jumpPage(0)">
            <img src="../../assets/home/sqmy.png" alt="">
            <p>社情民意</p>
          </div>
          <div class="flex_box" @click="jumpPage(1)">
            <img src="../../assets/home/zpjy.png" alt="">
            <p>招聘就业</p>
          </div>
          <div class="flex_box" @click="jumpPage(2)">
            <img src="../../assets/home/axbz.png" alt="">
            <p>爱心帮助</p>
          </div> -->
          <!--          <div class="flex_box">-->
          <!--            <img src="../../assets/home/cs.png" alt="">-->
          <!--            <p>9+1场所</p>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="home_top_second">
        <p class="home_top_title">外部入口</p>
        <div class="home_top_box">
          <!-- <div class="flex_box" @click="jumpPage(3)">
            <img src="../../assets/home/img/zhld.png" alt="">
            <p>智慧路灯</p>
          </div> -->
          <!-- <div class="flex_box" style="cursor: default" @click="jumpPage(6)">
            <img src="../../assets/home/img/zhny.png" alt="">
            <p>智慧农业</p>
          </div> -->
          <div class="flex_box" style="cursor: default">
            <img src="../../assets/home/img/qtpt.png" alt="">
            <p>其他平台</p>
          </div>
        </div>
      </div>
      <div class="home_top_third">
        <p class="time">{{todayDate.hour}}:{{todayDate.minutes}} <span>{{weatherInfo.wendu||0}}℃ | {{weatherInfo.fengxiang}}</span>
        </p>
        <p class="date">{{todayDate.year}}.{{todayDate.month}}.{{todayDate.dateStr}} {{todayDate.day}}</p>
      </div>
    </div>

    <div class="home_main">

      <div class="home_main_left">

        <div class="home_main_box">
          <div class="home_main_title">
          <span>工单信息<span class="huiji" v-show="gdList.length>0">{{gdList.length}}</span>
            <!--                    <Badge count="10" style="margin-left: 8px;"></Badge>-->
          </span>
            <el-select v-model="model1" class="select" @change="getTodoData" clearable>
              <el-option v-for="(item,index) in cityList" :key="index" :value="item.value"
                         :label="item.label"></el-option>
            </el-select>
          </div>
          <div class="outer_pad">
            <div class="home_main_table">
              <el-table
                :data="gdList"
                header-cell-class-name="table_header"
                v-show="gdList.length>0"
              >
                <el-table-column
                  prop="typeName"
                  label="工单类型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="工单标题"
                >
                </el-table-column>
                <el-table-column
                  prop="createdDate"
                  label="工单时间"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="工单状态"
                  width="100">
                  <template slot-scope="scope">
                    <span :class="scope.row.status==0? 'wcl':'ycl'">{{scope.row.status==0? '未处理':'已处理'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="110">
                  <template slot-scope="scope">
						      		<span class="caozuo" :class="scope.row.status==0? 'blue':''" @click="jumpPage(5)">
						      			{{scope.row.status==0? '去处理':'去查看'}}<img src="../../assets/home/img/jinru.png" alt=""> </span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="nolist" v-show="gdList.length==0">
                <img src="../../assets/home/img/zwgd.png" alt="">
                <p>暂无工单</p>
              </div>
            </div>
            <!-- <div class="home_main_content" v-for="(item,index) in gdList" :key="index">
              <p>{{item.title}}</p>
              <div>
                <span>{{item.typeName}}</span>
                <span>{{item.time}}</span>
                <span :class="item.status==0? 'wcl':'ycl'">{{item.status==0? '未处理':'已处理'}}</span>
              </div>
            </div> -->
          </div>
        </div>

        <div class="home_main_box">
          <div class="home_main_title">
          <span>巡查信息 <span class="huiji" v-show="xcList.length>0">{{xcList.length}}</span>
            <!--            <Badge count="2" style="margin-left: 8px;"></Badge>-->
          </span>
            <el-select v-model="model2" class="select" @change="getThreeOneData" clearable>
              <el-option v-for="(item,index) in xunchaSelection" :key="index" :value="item.value"
                         :label="item.label"></el-option>
            </el-select>
          </div>
          <div class="outer_pad">
            <div class="home_main_table">
              <el-table
                :data="xcList"
                header-cell-class-name="table_header"
                v-show="xcList.length>0"
              >

                <el-table-column
                  prop="typeName"
                  label="巡查类型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="content"
                  label="巡查标题"
                >
                </el-table-column>
                <el-table-column
                  prop="createdDate"
                  label="巡查时间"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="statusName"
                  label="巡查状态"
                  width="180">
                  <template slot-scope="scope">
                    <span :class="scope.row.statusName=='正常'? 'ycl':'wcl'">{{scope.row.statusName}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="nolist" v-show="xcList.length==0">
                <img src="../../assets/home/img/zwxc.png" alt="">
                <p>暂无巡查</p>
              </div>
            </div>
            <!-- <div class="home_main_content" v-for="(item,index) in xcList" :key="index">
              <p>{{item.content}}</p>
              <div>
                <span>{{item.typeName}}</span>
                <span>{{item.createdDate}}</span>
                <span :class="item.statusName=='正常'? 'ycl':'wcl'">{{item.statusName}}</span>
              </div>
            </div> -->
          </div>
        </div>

      </div>

      <div class="home_main_right">

        <div class="home_main_box" style="background-color: #F6F8FC">
          <div class="home_main_box_top">
            <div class="top">
              <span class="title">通知公告</span>
              <span class="more" @click="jumpPage(4)">更多</span>
            </div>
            <div class="list">
              <div class="list-item" v-for="(item,index2) in list" :key="index2" v-show="list.length>0">
                <span class="title"><span class="newicon" v-show="index2===0">NEW</span> {{item.content}}</span>
                <span class="time">{{formatDate(item.created_date)}}</span>
              </div>
              <div class="nolist" v-show="list.length==0">
                <img src="../../assets/home/img/zwgg.png" alt="">
                <p style="margin-top: -1.3rem;">暂无公告</p>
              </div>
            </div>
          </div>
          <div style="clear:both;"></div>

          <div class="home_main_box_bottom">
            <p class="title">日历</p>
            <zx-vue-calendar
              v-model="value"
              lang='zh'
              @change="handleChange"
              @cancel="handleCancel"
              @error="handleError"/>
          </div>

        </div>
      </div>

    </div>
    <!-- <p>{{$t('home.welcome')}}</p>
    <br>
    <br>
    <markdown></markdown> -->
    <!--    <img :src="url" alt="" style="width: 100%; height: 100%"/>-->
  </div>
</template>

<script>
  import util from '@/libs/util.js';
  import {ZxVueCalendar} from 'zx-calendar/lib/vue-calendar'
  import {Select, Option, Table, TableColumn} from 'element-ui'
  import Vue from 'vue'

  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Table)
  Vue.use(TableColumn)
  export default {
    components: {
      ZxVueCalendar
    },
    computed: {},
    data() {
      return {
        url: '',
        baseUrl: util.baseUrl,
        // this.baseUrl + params.row.appendixList[0].url + '/' + params.row.appendixList[0].targetFileName;
        xunchaSelection: [
          {
            value: 1,
            label: '出租房巡查'
          },
          {
            value: 2,
            label: '9+1巡查信息'
          },
          {
            value: 3,
            label: '企业安全生产巡查'
          },
        ],
        cityList: [
          {
            value: '1',
            label: '矛盾调解业务工单'
          },
          {
            value: '2',
            label: '随手拍业务工单'
          },
          {
            value: '0-1',
            label: '一键告警'
          },
          {
            value: '0-2',
            label: '烟感'
          },
          {
            value: '0-3',
            label: '燃气'
          },
          {
            value: '0-4',
            label: '摄像头'
          },
          {
            value: '0-4-1',
            label: '火点监测告警工单'
          },
          {
            value: '0-4-2',
            label: '漂浮物监测告警工单'
          },
          {
            value: '0-4-3',
            label: '不文明行为监测告警工单'
          }
        ],
        model2: null,
        model1: null,
        weatherInfo: {},
        todayDate: this.getDateObj(),
        gdList: [
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '1'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '1'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
        ],
        xcList: [
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '1'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '1'},
          {title: '某网格某某村民与邻居发生矛盾纠纷，事态发生矛盾纠纷21333333333322', type: '矛盾调解', time: '2022.08.11 10:42:56', status: '0'},
        ],
        list: [
          {title: '关于2022年人才培养方案建设的提问培养方案213afaafafffsdfa', type: '矛盾调解', time: '2022.08.11', status: '0'},
          {title: '关于2022年人才培养方案建设的提问培养方案213afaafafffsdfa', type: '矛盾调解', time: '2022.08.11', status: '0'},
          {title: '关于2022年人才培养方案建设的提问培养方案213afaafafffsdfa', type: '矛盾调解', time: '2022.08.11', status: '0'},
          {title: '关于2022年人才培养方案建设的提问培养方案213afaafafffsdfa', type: '矛盾调解', time: '2022.08.11', status: '0'},
          {title: '关于2022年人才培养方案建设的提问培养方案213afaafafffsdfa', type: '矛盾调解', time: '2022.08.11', status: '0'},
        ],
        value: '',
        timer: null
      }
    },
    created() {
      Promise.all([
        this.getTodayWeather(),
        this.getTodoData(),
        this.getThreeOneData(),
        this.getNoticeData(),
      ])
      this.$http.get("/api/getHomePagePicture").then(res => {
        // debugger;
        if (res.data.code == '-1') {
          this.url = require('../../assets/home-bg.png');
        }
        if (res.data.code == '0') {
          if (res.data.data === null) {
            return this.url = require('../../assets/home-bg.png');
          }
          let data = res.data.data.appendix;
          if (!data) {
            return this.url = require('../../assets/home-bg.png');
          }
          this.url = this.baseUrl + data.url + '/' + data.targetFileName;
        }
      })
    },
    mounted() {
      this.timer = setInterval(() => {
        this.todayDate = this.getDateObj()
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      getDateObj() {
        let tmp = new Date()

        let year = tmp.getFullYear()
        let month = tmp.getMonth() < 9 ? '0' + (tmp.getMonth() + 1) : tmp.getMonth() + 1
        let dateStr = tmp.getDate() < 10 ? '0' + tmp.getDate() : tmp.getDate()
        let hour = tmp.getHours() < 10 ? '0' + tmp.getHours() : tmp.getHours()
        let minutes = tmp.getMinutes() < 10 ? '0' + tmp.getMinutes() : tmp.getMinutes()
        let day = tmp.getDay()
        switch (day) {
          case 1:
            day = '星期一'
            break;
          case 2:
            day = '星期二'
            break;
          case 3:
            day = '星期三'
            break;
          case 4:
            day = '星期四'
            break;
          case 5:
            day = '星期五'
            break;
          case 6:
            day = '星期六'
            break;
          case 7:
            day = '星期日'
            break;
        }
        return {year, month, dateStr, hour, minutes, day}
      },
      formatDate(date) {
        let tmp = new Date(date)

        let year = tmp.getFullYear()
        let month = tmp.getMonth() < 9 ? '0' + (tmp.getMonth() + 1) : tmp.getMonth() + 1
        let dateStr = tmp.getDate() < 10 ? '0' + tmp.getDate() : tmp.getDate()

        return year + "-" + month + "-" + dateStr
      },

      getNoticeData() {
        let url = 'api/getNoticesByCriteria?title.contains=&page=0&size=5'
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.list = res.data.datas
          }
        })
      },
      getThreeOneData() {
        let url = 'api/tPlatformOne/getThreeCheck'
        if (this.model2) {
          url = url + '?type=' + this.model2
        }
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            this.xcList = res.data.data
          }
        })
      },
      getTodoData() {
        let url = 'api/threeScreen/pageTodo'
        if (this.model1) {
          url = url + '?sourceType=' + this.model1
        }
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            this.gdList = res.data.data.list
          }
        })
      },

      getTodayWeather() {
        this.$http.get('api/emScren/getWeather').then(res => {
          if (res.data.code == 200) {
            this.weatherInfo = res.data.data.weather
          }
        })

      },
      jumpPage(index) {
        switch (index) {
          case 0:
            this.$router.push('/culturePlace/publicOpinion')
            break;
          case 1:
            this.$router.push('/lifeCare/jobRecruitment/enterpriseRecruitment')
            break;
          case 2:
            this.$router.push('/lifeCare/poorDefeat/accurateSupport')
            break;
          case 3:
            // window.open('http://mind.suzhoulamp.cn/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/')
            // window.open('https://city.suzhoulamp.cn/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/index.new.jsp?wid=213')
            window.open('http://47.96.126.134:8088/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/index.new.jsp?wid=213')
            break;
          case 4:
            this.$router.push('/culturePlace/notice')
            break;
          case 5:
            this.$router.push('/workOrder/workOrder')
            break;
          case 6:
            window.open('https://www.crop-data.cn/ragis_server_hexinyun/user/singleLogin?userName=相城区农业农村局&password=f6a5295803c62d9f3c803d63768db569')
            break;
        }
      },
      handleChange(value, orignal) {
        // console.log(value, orignal)
      },
      handleCancel() {
        // console.log('button cancel on click!')
      },
      handleError(err) {
        // console.error(err)
      }
    },
  }
</script>
